module.exports = __webpack_public_path__ + "static/media/globe.d2b77a18.png";